import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { UAParser } from 'ua-parser-js';

@Injectable()
export class TenantClientInfoInterceptor implements HttpInterceptor {

  private get(key: string): string | null {
    try { return localStorage.getItem(key); } catch { return null; }
  }
  private set(key: string, val: string): void {
    try { localStorage.setItem(key, val); } catch {}
  }

  private ensureClientTraceId(): string {
    let id = this.get('clientTraceId');
    if (!id) {
      const chars = 'ABCDEFGHJKLMNOPRSTUVWXYZ23456789';
      let r = 'CT-';
      for (let i = 0; i < 6; i++) r += chars.charAt(Math.floor(Math.random() * chars.length));
      this.set('clientTraceId', r);
      id = r;
    }
    return id;
  }

  private ensureClientInfo(): string {
    let info = this.get('clientInfo');
    if (!info) {
      const p = new UAParser(navigator.userAgent);
      const clientInfo = { device: p.getDevice(), os: p.getOS(), browser: p.getBrowser() };
      info = JSON.stringify(clientInfo);
      this.set('clientInfo', info);
    }
    return info!;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headers: Record<string, string> = {};

    const tenant = this.get('tenant');
    if (tenant) headers['X-Global-Tenant'] = tenant;

    headers['X-Client-TraceId'] = this.ensureClientTraceId();
    headers['X-Client-Info'] = this.ensureClientInfo();

    const authReq = Object.keys(headers).length
      ? req.clone({ setHeaders: headers })
      : req;

    return next.handle(authReq).pipe(
      tap(evt => {
        if (evt instanceof HttpResponse) {
          const tenantHeader = evt.headers.get('X-Global-Tenant');
          if (tenantHeader) this.set('tenant', tenantHeader);
        }
      })
    );
  }
}
